import { render } from "./QuestionnaireQuestion.vue?vue&type=template&id=0db118ae&scoped=true"
import script from "./QuestionnaireQuestion.vue?vue&type=script&lang=js"
export * from "./QuestionnaireQuestion.vue?vue&type=script&lang=js"

import "./QuestionnaireQuestion.vue?vue&type=style&index=0&id=0db118ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db118ae"]])

export default __exports__